import { TypePolicies } from "@apollo/client";

/**
 * Cache-Konfiguration des Apollo Clients — bewusst aus `client.tsx` ausgelagert,
 * damit sie ohne Keycloak/Sentry-Seiteneffekte getestet werden kann
 * (siehe `src/utils/graphqlCacheSafety.test.ts`).
 */
export const typePolicies: TypePolicies = {
    IoTGateway: {
        keyFields: ["imei"],
    },
    ContaminationDeclaration: {
        fields: {
            // `ContaminationDeclarationValidity` hat kein `id`, wird also inline
            // an der Entity abgelegt und bei jedem Write ersetzt. Alle Dokumente
            // selektieren es zwar über dasselbe Fragment — das Merge ist der
            // Gurt dazu, falls doch einmal eine Teilmenge geschrieben wird
            // (z.B. der Rückschreib-Pfad des Druck-Hooks).
            validity: { merge: true },
        },
    },
    // Netzwerkscan (IBM-1039): `NetworkScan`/`EffectiveNetworkScan` haben kein
    // `id`, liegen also inline an der Entity und würden bei jedem Write ersetzt.
    // Tab, Detail-Panel, „Dokumentiert von“-Lookup und Mutationen schreiben
    // dasselbe Feld — ohne Merge würde ein Write mit kleinerer Selection das
    // Dokument eines anderen unvollständig machen und eine Refetch-Schleife
    // auslösen.
    InstalledBaseNode: {
        fields: {
            networkScan: { merge: true },
        },
    },
    AssetLocation: {
        fields: {
            effectiveNetworkScan: { merge: true },
        },
    },
    System: {
        fields: {
            effectiveNetworkScan: { merge: true },
        },
    },
    Query: {
        fields: {
            // Diese Felder liefern einen Wrapper-Typ ohne `id` im Schema, also
            // legt Apollo sie inline unter ROOT_QUERY ab und *ersetzt* sie bei
            // jedem Write komplett. Die Tree-Spalten und die
            // InfrastructureBrowser/-Select-Picker schreiben auf denselben
            // Store-Key (gleiche Feld-Args) mit unterschiedlicher Selection —
            // ohne explizites Merge löscht der Picker-Write den paginierten
            // `installedBaseNodes(pagination:)`-Subkey der Spalten samt aller
            // per fetchMore gemergten Seiten. Deshalb: deep-mergen.
            installedBaseNodeList: { merge: true },
            installedBaseRootNodeList: { merge: true },
            // Gleiche Falle bei den Kontakten: der Assign-Picker und die
            // TDA-Queries schreiben ROOT_QUERY.contactPersonList mit gleichen
            // Args (clientId-Filter) aber disjunkter Selection.
            contactPersonList: { merge: true },
            contactRoleList: { merge: true },
        },
    },
};
